import React from 'react';
import { Infinity } from 'lucide-react';

export const Logo = ({ dark = false, size = 'text-2xl', markClass = '' }) => (
  <span className="inline-flex items-center gap-2">
    <Infinity
      className={markClass || (size === 'text-xl' ? 'w-6 h-6' : 'w-7 h-7')}
      strokeWidth={2.5}
      color={dark ? '#2997FF' : '#0071E3'}
      data-testid="logo-mark"
    />
    <span className={`${size} font-semibold tracking-tight leading-none`}>
      <span className={dark ? 'text-white' : 'text-[#1D1D1F]'}>Invicta</span>
      <span className={dark ? 'text-[#2997FF]' : 'text-[#0071E3]'}>Flow</span>
    </span>
  </span>
);

export default Logo;
